module.exports = __webpack_public_path__ + "images/frontpage_desktop@2x.jpg?30084b96";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_desktop@2x.jpg
// module id = 634
// module chunks = 7